import script from "./userinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./userinfo.vue?vue&type=script&setup=true&lang=js"

import "./userinfo.vue?vue&type=style&index=0&id=55214c9e&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55214c9e"]])

export default __exports__